"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTypeRest = function () {
  function DataTypeRest($http) {
    (0, _classCallCheck3.default)(this, DataTypeRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      DATA_TYPES_LIST: 'datatypes/'
    };
  }

  (0, _createClass3.default)(DataTypeRest, [{
    key: "getList",
    value: function getList(params) {
      return this.$http.get(this.PATH.DATA_TYPES_LIST, { params: params });
    }
  }]);
  return DataTypeRest;
}();

exports.default = DataTypeRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/DataTypeResource.js
// module id = 324
// module chunks = 0